import { useEffect, useState } from "react";
import { subscriptionsApi } from "../lib/subscriptionsApi";

/** Puxa e mantém em cache o summary do Clube de Assinatura (KPIs + alertas). */
export const useSubscriptionsSummary = (pollMs = 60000) => {
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const fetch = async () => {
            try {
                const s = await subscriptionsApi.summary();
                if (!cancelled) setSummary(s);
            } catch (_) { /* silencioso */ }
        };
        fetch();
        const t = setInterval(fetch, pollMs);
        return () => { cancelled = true; clearInterval(t); };
    }, [pollMs]);

    return summary;
};

export default useSubscriptionsSummary;
